import { Navigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { APP_CONFIG } from '@/config/app';
import { lastPortalSlug } from './returnTo';

/** `/portal` has no company in the URL: bounce to the last one used, else explain. */
export default function PortalIndex() {
  const slug = lastPortalSlug();
  if (slug) return <Navigate to={`/portal/${slug}`} replace />;

  return (
    <div className="min-h-screen bg-muted flex items-center justify-center p-4">
      <Card className="w-full max-w-md text-center">
        <CardContent className="pt-8 pb-8">
          <Mail className="mx-auto mb-4 h-12 w-12 text-primary" />
          <h1 className="mb-2 text-lg font-semibold">Open the link from your email</h1>
          <p className="text-sm text-muted-foreground">
            Your account page is reached through the link your service provider emailed you.
            If you can't find it, ask them to send a new one.
          </p>
          <p className="mt-6 text-xs text-muted-foreground">Powered by {APP_CONFIG.name}</p>
        </CardContent>
      </Card>
    </div>
  );
}
